import { supabase } from "@shared/lib/supabase/client";
import type { SupabaseTable, TableColumn } from "@shared/types/query";
import { useQuery } from "@tanstack/react-query";

export function useTables(limit: number = 0) {
  return useQuery<SupabaseTable[], Error>({
    queryKey: ["supabase-tables", limit],
    queryFn: async () => {
      let query = supabase.rpc("get_tables");
      if (limit > 0) {
        query = query.limit(limit);
      }
      const { data, error } = await query;
      if (error) throw new Error(error.message);
      return data as SupabaseTable[];
    },
    staleTime: 1000 * 60 * 5,
  });
}

export function useTableColumns(tableName: string | undefined) {
  return useQuery<TableColumn[], Error>({
    queryKey: ["table-columns", tableName],
    queryFn: async () => {
      if (!tableName) return [];

      const { data, error } = await supabase.rpc("get_table_columns", {
        p_table_name: tableName,
      });

      if (error) throw new Error(error.message);
      return (data as TableColumn[]) || [];
    },

    enabled: !!tableName,
  });
}
